import React from 'react';
import { Box, Text, Grid } from '@chakra-ui/react';


const Card = (props) => {
    const {color, title, text} = props;
  return (
    <Box w={['15rem','15rem','15rem','20em']} h={['15rem','15rem','15rem','20em']} borderRadius='24px' p='2rem' color='#000' display='flex' flexDirection='column' justifyContent='center' alignItems='center' bg={color}>
        <Text textAlign='center'fontWeight='600' fontSize={['1.35rem','1.3rem','1.3rem','32px']} >{title}</Text>
        <Text color='#445368' textAlign='center' fontFamily='Work Sans' fontSize={['.75rem','.8rem','.8rem', '1rem']} mt='1rem' lineHeight='28px' >{text}</Text>
    </Box>
  )
}

const Feature = () => {
  return (
    <Box
      h="100%"
      w="full"
      bg='#f2f2f4'
      p="3rem"
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
    >
      <Text
        fontSize={['1.5rem', '2rem', '2.3rem', '3rem']}
        textAlign="center"
        fontWeight="500"
        fontFamily='Duplicate Sans'
      >
        Features
      </Text>
      <Text
        fontSize={['.75rem', '.8rem', '.8rem', '1rem']}
        lineHeight="28px"
        fontFamily='Work Sans'
        mt="1rem"
        textAlign="center"
        color="#445368"
      >
       We created NeemblePay because we want to help the banked community
      </Text>
      <Grid
        mt="5rem"
        p="1rem"
        templateColumns={[
          'repeat(1,1fr)',
          'repeat(2,1fr)',
          'repeat(2,1fr)',
          'repeat(3,1fr)',
        ]}
        gap={['6', '6', '6', '12']}
      >
        <Card
          color="#fff"
          title="Teamwork"
          text="We are a family at Neemble, so we 
leverage on each other’s skills to
create amazing solutions."
        />
        <Card
          color="#fff"
          title="Transparency"
          text="We are a family at Neemble, so we 
leverage on each other’s skills to
create amazing solutions."
        />
        <Card
          color="#fff"
          title="Trust"
          text="We are a family at Neemble, so we 
leverage on each other’s skills to
create amazing solutions."
        />
      </Grid>
    </Box>
  );
};

export default Feature;
